module.exports = __webpack_public_path__ + "img/arrow-right.e1ef2d71.svg";